// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowPreview-cls1_GPU","cls2":"BulkFollowPreview-cls2_H-M BulkFollowPreview-cls1_GPU"};